import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const BankCardIcon = ({
  width = 25,
  height = 25,
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      fill: color,
      width: width,
      height: height
    }}
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    className="icon icons8-Bank-Cards-Filled"
  >
    <g id="surface1">
      <path d="M 6 5 C 3.792969 5 2 6.792969 2 9 L 2 12 L 44 12 L 44 9 C 44 6.792969 42.207031 5 40 5 Z M 2 17 L 2 31 C 2 33.207031 3.792969 35 6 35 L 40 35 C 42.207031 35 44 33.207031 44 31 L 44 17 Z M 9 20 L 25 20 L 25 22 L 9 22 Z M 46 24.0625 L 46 31 C 46 34.308594 43.308594 37 40 37 L 6 37 C 5.878906 37 5.746094 36.976563 5.625 36.96875 L 6.59375 42.3125 C 6.78125 43.367188 7.34375 44.296875 8.21875 44.90625 C 8.898438 45.382813 9.6875 45.625 10.5 45.625 C 10.734375 45.625 10.984375 45.605469 11.21875 45.5625 L 44.6875 39.59375 C 45.738281 39.40625 46.671875 38.8125 47.28125 37.9375 C 47.890625 37.0625 48.125 36.019531 47.9375 34.96875 Z " />
    </g>
  </IconSvg>
)

export default BankCardIcon
